
export default {

  methods: {

    calcCost(product) {
      
      let purchase_price = this.parseValue(product.purchase_price)
      let st = this.parseValue(product.st)
      let ipi = this.parseValue(product.ipi)
      let shipping = this.parseValue(product.shipping)

      let costPriceTaxesFactor = 1 + ((st + ipi) / 100);
      
      let costPrice = purchase_price *  costPriceTaxesFactor + shipping;
      
      return costPrice

    },
    
    calcProfit(product) {
      
      let icms_credit = this.parseValue(product.icms_credit)
      let pis_credit = this.parseValue(product.pis_credit)
      let cofins_credit = this.parseValue(product.cofins_credit)
      let icms_debt = this.parseValue(product.icms_debt)
      let pis = this.parseValue(product.pis)
      let cofins = this.parseValue(product.cofins)
      let commission = this.parseValue(product.commission)
      let price_cash = this.parseValue(product.price_cash)
      let purchase_price = this.parseValue(product.purchase_price)

      let costPrice = this.calcCost(product)

      let purchaseCreditValue = ((icms_credit + pis_credit + cofins_credit) / 100) * purchase_price;

      let sellPriceTaxesFactor = (icms_debt + pis + cofins + commission ) / 100; 
      
      let sellExpensesValue = price_cash * sellPriceTaxesFactor;

      let profit = 0;

      if (price_cash != 0) {

          profit = 100 * (1 - ((costPrice + sellExpensesValue - purchaseCreditValue) / price_cash));

      }
      // console.log(profit)

      return profit
    },

    // calcIdealPrice

    calcPriceForward(product) {
      let price_cash = this.parseValue(product.price_cash)
      
      return price_cash / 0.85
    },

    parseValue(value) {
      
      if (value) {
        return parseFloat(value)
      }
      
      return 0
    }
  }
  
}